module.exports = __webpack_public_path__ + "img/93.de72fdc6.jpg";